import { render, staticRenderFns } from "./index.vue?vue&type=template&id=699834c3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699834c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699834c3')) {
      api.createRecord('699834c3', component.options)
    } else {
      api.reload('699834c3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=699834c3&scoped=true&", function () {
      api.rerender('699834c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/index.vue"
export default component.exports